import { Button, ButtonProps, useColorModeValue } from "@chakra-ui/react"
import { useFormikContext } from "formik"

export function useIsSubmissionDisabled(): boolean {
  const form = useFormikContext()
  return form
    ? form.isSubmitting ||
        !form.isValid ||
        (!form.dirty && !form.validateOnMount)
    : true
}

const SubmitButton = (props: ButtonProps): JSX.Element => {
  const form = useFormikContext()
  const colorScheme = useColorModeValue("brand", undefined)
  const isSubmissionDisabled = useIsSubmissionDisabled()

  return (
    <Button
      variant="solid"
      colorScheme={colorScheme}
      type="submit"
      width="full"
      isLoading={form.isSubmitting}
      isDisabled={isSubmissionDisabled}
      {...props}
    />
  )
}

export default SubmitButton
